package link.erpango.quip.ui

import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.DatePicker
import androidx.compose.material3.DatePickerDialog
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.material3.TextFieldColors
import androidx.compose.material3.TextFieldDefaults
import androidx.compose.material3.rememberDatePickerState
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import link.erpango.quip.ui.components.QuipTextField
import link.erpango.quip.utils.DatetimeUtils
import compose.icons.FontAwesomeIcons
import compose.icons.fontawesomeicons.Solid
import compose.icons.fontawesomeicons.solid.Calendar
import link.erpango.quip.QuipConstants
import link.erpango.quip.theme.QuipColors
import link.erpango.quip.ui.components.QuipTextFieldDefaults
import androidx.compose.material3.DatePickerDefaults
import androidx.compose.material3.ButtonDefaults

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun DatePickerField(
    label: String,
    currentDate: Long?,
    onDateSelected: (Long) -> Unit,
    helperText: @Composable (() -> Unit)? = null
) {
    var showDatePicker by remember { mutableStateOf(false) }
    Column {
        Box(
            Modifier
            .fillMaxWidth()
            .then(
                Modifier.clickable(
                    onClick = {
                        showDatePicker = true
                    },
                    indication = null,
                    interactionSource = remember { MutableInteractionSource() }
                )
            )
        ) {

            // We use a read-only TextField that visits the DatePicker on click
            QuipTextField(
                value = currentDate?.let { DatetimeUtils.dateToSpecificFormat(DatetimeUtils.getDateFromMilis(it.toString()), format = QuipConstants.DateFormat.noUtcPatternSpanishWithoutTime) } ?: "",
                onValueChange = { },
                label = label,
                icon = FontAwesomeIcons.Solid.Calendar,
                readOnly = true,
                enabled = false,
                colors = TextFieldDefaults.colors().copy(
                    disabledTextColor = QuipColors.black,
                    disabledContainerColor = QuipColors.white,
                ),
                helperText = helperText
            )
        }
    }

    if (showDatePicker) {
        val datePickerState = rememberDatePickerState(
            initialSelectedDateMillis = currentDate ?: DatetimeUtils.currentTimeMillis()
        )

        DatePickerDialog(
            onDismissRequest = { showDatePicker = false },
            colors = DatePickerDefaults.colors(
                containerColor = QuipColors.colorBackground,
            ),
            confirmButton = {
                TextButton(
                    onClick = {
                    datePickerState.selectedDateMillis?.let { onDateSelected(it) }
                    showDatePicker = false
                },
                    colors = ButtonDefaults.textButtonColors(
                        contentColor = QuipColors.colorText
                    )
                ) {
                    Text("OK")
                }
            },
            dismissButton = {
                TextButton(
                    onClick = { showDatePicker = false },
                    colors = ButtonDefaults.textButtonColors(
                        contentColor = QuipColors.colorText
                    )
                ) {
                    Text("Cancel")
                }
            }
        ) {
            DatePicker(
                state = datePickerState,
                colors = DatePickerDefaults.colors(
                    containerColor = QuipColors.colorBackground,
                    titleContentColor = QuipColors.colorText,
                    headlineContentColor = QuipColors.colorText,
                    weekdayContentColor = QuipColors.colorText,
                    subheadContentColor = QuipColors.colorText,
                    yearContentColor = QuipColors.colorText,
                    currentYearContentColor = QuipColors.colorText,
                    selectedYearContentColor = QuipColors.white,
                    selectedYearContainerColor = QuipColors.colorPrimary,
                    dayContentColor = QuipColors.colorText,
                    disabledDayContentColor = QuipColors.colorText.copy(alpha = 0.38f),
                    selectedDayContentColor = QuipColors.white,
                    selectedDayContainerColor = QuipColors.colorPrimary,
                    todayDateBorderColor = QuipColors.colorPrimary,
                    todayContentColor = QuipColors.colorText
                )
            )
        }
    }
}
